// extracted by mini-css-extract-plugin
module.exports = {"inputsContainer":"input-page-range_inputsContainer__PxL2W","inputContainer":"input-page-range_inputContainer__DOr4U"};